export const TASKS_LOAD = '@tasks/load';
export const TASKS_NEXT = '@tasks/next';
export const TASKS_PREV = '@tasks/prev';
export const TASK_BY_ID = '@task/by-id';
